import React, { useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useOthersStore } from "../../store/othersStore.js";
import { Input, message } from "antd";

import { CopyToClipboard } from "../../utils/copytoclipboard";

import Loader from "../../components/loader/loader";
import { PrimaryButton, VioletButtonLarge } from "../../components/button";

const { TextArea } = Input;

const AddAuthor = () => {
  const location = useLocation();
  const { addAuthor, getAuthors, uploadFile, isFileLoading } =
    useOthersStore();
  const navigate = useNavigate();

  const id = location?.pathname?.split("/")[2];

  const [uploadedURL, setUploadedURL] = useState("");
  const [state, setState] = useState({
    description: "",
    displayName: "",
    facebookLink: "",
    instagramLink: "",
    twitterLink: "",
    redditLink: "",
    tumblrLink: "",
    quoraLink: "",
    imageUrl: "",
    profileTitle: "",
    userEmail: "",
    userLogin: "",
  });

  const handleCopy = async () => {
    if (await CopyToClipboard(uploadedURL)) {
      message.success("Copied to clipboard!");
    }
  };

  const handleFileUpload = (file) => {
    const formData = new FormData();
    formData.append("image", file);

    uploadFile(formData, (res) => {
      console.log(res);
      if (res.status === 200) {
        setUploadedURL(res.imageUrl);
        document.getElementById("imageUploader").value = "";
      }
    });
  };

  const handleSubmit = () => {
    const requiredFields = [
      state?.description,
      state?.displayName,
      state?.imageUrl,
      state?.profileTitle,
      state?.userEmail,
    ];

    const isValid = requiredFields.every(
      (field) => field && (field?.length > 0 || field.trim() !== "")
    );

    if (!isValid) {
      message.error("Please fill all the required fields");
      return;
    }

    const removeEmptyFields = (obj) => {
      return Object.entries(obj)
        .filter(
          ([_, value]) => value !== "" && value !== null && value !== undefined
        )
        .reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]:
              typeof value === "object" && !Array.isArray(value)
                ? removeEmptyFields(value)
                : value,
          }),
          {}
        );
    };

    const cleanedState = removeEmptyFields(state);

    const payload = { ...cleanedState };

    addAuthor(payload, (res) => {
      if (res.status === 200) {
        getAuthors({});
        navigate("/author");
      }
    });
  };

  return (
    <div className="px-3 py-4 flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-2">
          <div>Name *</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Author name"
            onChange={(e) =>
              setState({
                ...state,
                displayName: e.target.value,
                userLogin: e.target.value,
              })
            }
            value={state.displayName}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Email *</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            type="email"
            placeholder="Email"
            onChange={(e) => setState({ ...state, userEmail: e.target.value })}
            value={state.userEmail}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Description *</div>

          <TextArea
            rows={4}
            className="moneyPage"
            placeholder="Description"
            onChange={(e) =>
              setState({ ...state, description: e.target.value })
            }
            value={state.description}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Title *</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Title"
            onChange={(e) =>
              setState({ ...state, profileTitle: e.target.value })
            }
            value={state.profileTitle}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>
            Image Uploader (after uploading, copy the link and paste it in
            featured image)
          </div>
          {isFileLoading ? (
            <Loader />
          ) : (
            <div className="flex gap-3">
              <input
                type="file"
                id="imageUploader"
                accept="image/*"
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (file) {
                    handleFileUpload(file);
                  }
                }}
                className="p-4 text-[18px] font-medium rounded-lg border border-gray-400 cursor-pointer w-max"
              />
              {uploadedURL && (
                <div className="flex items-center gap-3">
                  <div className="p-2 border rounded bg-gray-100 text-gray-700">
                    <span>Uploaded Image URL: </span>
                    <Link
                      to={uploadedURL}
                      target="_blank"
                      className="font-semibold"
                    >
                      {uploadedURL}
                    </Link>
                  </div>
                  <button
                    onClick={handleCopy}
                    className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                  >
                    Copy
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="flex flex-col gap-2">
          <div>Profile Image *</div>

          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Image Url"
            onChange={(e) => setState({ ...state, imageUrl: e.target.value })}
            value={state.imageUrl}
          />
          {state.imageUrl && (
            <img
              src={state?.imageUrl}
              className="h-[150px] w-max"
              alt="featured"
            />
          )}
        </div>
        <div className="grid grid-cols-3 gap-5">
          <div className="flex flex-col gap-2">
            <div>Facebook Link</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="facebook"
              onChange={(e) =>
                setState({ ...state, facebookLink: e.target.value })
              }
              value={state.facebookLink}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Instagram Link</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Title"
              onChange={(e) =>
                setState({ ...state, instagramLink: e.target.value })
              }
              value={state.instagramLink}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Reddit Link</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Title"
              onChange={(e) =>
                setState({ ...state, redditLink: e.target.value })
              }
              value={state.redditLink}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Tumblr Link</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Title"
              onChange={(e) =>
                setState({ ...state, tumblrLink: e.target.value })
              }
              value={state.tumblrLink}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div>Quora Link</div>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Title"
              onChange={(e) =>
                setState({ ...state, quoraLink: e.target.value })
              }
              value={state.quoraLink}
            />
          </div>
        </div>
      </div>

      <div className="flex gap-3 items-center">
        <PrimaryButton
          text="Save"
          style={{ width: "200px" }}
          onClick={handleSubmit}
        />
        <VioletButtonLarge
          text="Cancel"
          style={{ width: "200px" }}
          onClick={() => window.history.back()}
        />
      </div>
    </div>
  );
};

export default AddAuthor;








